class FAQAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.questions = this.querySelectorAll('.faq-question');
    this.questions.forEach((question) => {
      question.addEventListener('click', this.toggle.bind(this));
    });
  }

  toggle(event) {
    const question = event.currentTarget;
    const answer = question.nextElementSibling;
    const toggleIcon = question.querySelector('.faq-toggle');

    const isOpen = window.getComputedStyle(answer).display !== 'none';

    this.querySelectorAll('.faq-answer').forEach((otherAnswer) => {
      if (otherAnswer !== answer && window.getComputedStyle(otherAnswer).display !== 'none') {
        this.close(otherAnswer);
        const otherIcon = otherAnswer.previousElementSibling.querySelector('.faq-toggle');
        if (otherIcon) otherIcon.classList.remove('faq-toggle--active');
      }
    });

    if (isOpen) {
      this.close(answer);
      toggleIcon.classList.remove('faq-toggle--active');
    } else {
      this.open(answer);
      toggleIcon.classList.add('faq-toggle--active');
    }
  }

  open(element) {
    element.style.display = 'block';
    element.style.overflow = 'hidden';
    const height = element.scrollHeight + 'px';
    element.style.height = '0px';
    element.style.transition = 'height 0.3s ease';

    requestAnimationFrame(() => {
      element.style.height = height;
    });

    element.addEventListener(
      'transitionend',
      () => {
        if (element.style.height !== '0px') {
          element.style.height = 'auto';
        }
      },
      { once: true }
    );
  }

  close(element) {
    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = 'hidden';
    element.style.transition = 'height 0.3s ease';

    requestAnimationFrame(() => {
      element.style.height = '0px';
    });

    element.addEventListener(
      'transitionend',
      () => {
        if (element.style.height === '0px') {
          element.style.display = 'none';
        }
      },
      { once: true }
    );
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FAQAccordion);
}
